/**
 * Initialisation de l'animation p5.js (Traînée de souris)
 * @param {HTMLElement} containerNode - Le conteneur DOM cible (div React)
 */
export function initP5Trajet(containerNode) {
  
  // Configuration du sketch en mode instance
  const sketch = (p) => {
    
    // Historique des positions du curseur
    let historiquePositions = []; 
    const LONGUEUR_MAX_TRAINEE = 12;

    /**
     * Calcule un format adapté (Rectangle sur mobile, Carré sur desktop)
     */
    function calculerTailleCanvas() {
      if (window.innerWidth < 740) {
        // Sur mobile : 100% de la largeur, et 60% de la hauteur de l'écran
        return { 
          largeur: window.innerWidth, 
          hauteur: window.innerHeight * 0.6 
        };
      }
      // Sur desktop : Carré classique
      return { largeur: 700, hauteur: 700 };
    }

    p.setup = () => {
      let dimensions = calculerTailleCanvas();
      p.createCanvas(dimensions.largeur, dimensions.hauteur);
      
      historiquePositions = [];
    };

    p.draw = () => {
      // Fond avec une très faible opacité (30) pour créer l'effet de rémanence globale
      p.background(20, 25, 35, 30);
      
      // Enregistrement de la position actuelle de la souris à chaque frame
      historiquePositions.push({ x: p.mouseX, y: p.mouseY });
      
      // Maintien de la taille maximale du tableau (suppression de la plus vieille position)
      if (historiquePositions.length > LONGUEUR_MAX_TRAINEE) {
        historiquePositions.shift();
      }
      
      // Rendu de la traînée (itération de la plus récente à la plus ancienne)
      for (let i = historiquePositions.length - 1; i >= 0; i--) {
        let position = historiquePositions[i];
        
        // Calcul proportionnel de la taille et de l'opacité selon l'ancienneté du point
        // map(valeur, minOrigine, maxOrigine, minCible, maxCible)
        let tailleCercle = p.map(i, 0, historiquePositions.length - 1, 100, 30);
        let opacite = p.map(i, 0, historiquePositions.length - 1, 255, 50);
        
        // Rendu du cercle
        p.fill(56, 189, 248, opacite);
        p.noStroke();
        p.ellipse(position.x, position.y, tailleCercle, tailleCercle);
      }
    };

    // Ajustement des dimensions lors du redimensionnement de la fenêtre
    p.windowResized = () => {
      let dimensions = calculerTailleCanvas();
      p.resizeCanvas(dimensions.largeur, dimensions.hauteur);
    };
  };

  // Instanciation de p5.js
  const p5Instance = new window.p5(sketch, containerNode);

  // Fonction de nettoyage pour le démontage du composant
  return () => {
    p5Instance.remove();
  };
}